import { render } from "./EntityListingRow.vue?vue&type=template&id=41f779ba&scoped=true"
import script from "./EntityListingRow.vue?vue&type=script&lang=js"
export * from "./EntityListingRow.vue?vue&type=script&lang=js"

import "./EntityListingRow.vue?vue&type=style&index=0&id=41f779ba&lang=scss&scoped=true"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f779ba"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
